const reduxKeys = {
    SET_USER_DATA: "SET_USER_DATA",
    SET_INVENTORY_FILTERS: "SET_INVENTORY_FILTERS",
    SET_SUPPLIERS: "SET_SUPPLIERS",
    SET_WAREHOUSE: "SET_WAREHOUSE",
    SET_COMPANIES: "SET_COMPANIES",
    SET_INSTALLERS: "SET_INSTALLERS",
    SET_SOFTWARE_PROVIDER: "SET_SOFTWARE_PROVIDER",
    SET_BILLING_COMPANIES: "SET_BILLING_COMPANIES",
    SET_COMPANY_REQUEST_TYPE: "SET_COMPANY_REQUEST_TYPE",
    SET_USERS_ROLES: "SET_USERS_ROLES",
    SET_ALLOWED_PAGES: "SET_ALLOWED_PAGES",
    SET_PROFILE: "SET_PROFILE"
}

export default reduxKeys;